import React, { useState, useEffect } from 'react';
import '../styles/ExplorePage.css';
import MapComponent from './MapComponent';
import BreakdownList from './BreakdownList';
import { fetchSpeciesInRadius } from '../services/inaturalist';
import { saveSearch } from '../services/firebase-service';

function ExplorePage({ searchLocation, selectedRadius, setSelectedRadius, onSearch }) {
  const [speciesData, setSpeciesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedSpecies, setSelectedSpecies] = useState(null);
  const [showBreakdown, setShowBreakdown] = useState(false);

  // Default map center (continental US) when no search has been made
  const defaultCenter = { lat: 39.8283, lng: -98.5795 };
  const mapCenter = searchLocation || defaultCenter;

  useEffect(() => {
    if (!searchLocation) return; // Don't fetch until the user searches

    const loadSpecies = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchSpeciesInRadius(
          searchLocation.lat,
          searchLocation.lng,
          selectedRadius
        );
        setSpeciesData(data);

        // Save search to Firestore (fire-and-forget)
        saveSearch(searchLocation, selectedRadius, data.length);
      } catch (err) {
        console.error('Error fetching species:', err);
        setError('Failed to load species data');
      } finally {
        setLoading(false);
      }
    };

    loadSpecies();
  }, [searchLocation, selectedRadius]);

  const handleSpeciesClick = (species) => {
    setSelectedSpecies(species || null);
  };

  return (
    <div className="explore-page">
      <MapComponent
        center={[mapCenter.lat, mapCenter.lng]}
        zoom={searchLocation ? 11 : 4}
        showSpecies={!!searchLocation}
        speciesData={speciesData}
        selectedRadius={selectedRadius}
        searchLocation={searchLocation}
        onSpeciesClick={handleSpeciesClick}
        selectedSpeciesId={selectedSpecies?.id}
      />

      {searchLocation && (
        <BreakdownList
          speciesData={speciesData}
          isVisible={showBreakdown}
          setIsVisible={setShowBreakdown}
          selectedSpecies={selectedSpecies}
          setSelectedSpecies={setSelectedSpecies}
          loading={loading}
          locationName={searchLocation?.cityState || searchLocation?.name}
        />
      )}

      {loading && !showBreakdown && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading species data...</p>
        </div>
      )}

      {error && (
        <div className="error-indicator">
          <p>{error}</p>
        </div>
      )}
    </div>
  );
}

export default ExplorePage;
